module.exports = __webpack_public_path__ + "img/02.cd2b624a.jpg";